@if (isLoading) {
  <div class="step-loading">
    <mat-spinner style="height: 50px !important"></mat-spinner>
  </div>
}

@if (!isLoading) {
  <div class="filter-box">
    <div class="action-group">
      <mat-checkbox
        (change)="setAll($event.checked)"
        [checked]="allSelected"
        [color]="'primary'"
      >Select all</mat-checkbox>
      @if (authService.hasPermission(Permission.PostAssetsPreRelease)) {
        <button
          mat-stroked-button
          class="download-multiple"
          (click)="downloadMultiple()"
          [disabled]="disableButtonDownload()"
          >
          <mat-icon>file_download</mat-icon>Download{{ "(" + selectedCount + ")" }}
        </button>
      }
    </div>
    <div class="filter-group">
      <app-enhancement-variants-change-action
        [product]="product"
        [enhancementVariantIdSelected]="enhancementVariantIdSelected"
        (enhancementVariantChanged)="onEnhancementVariantChanged($event)"
      ></app-enhancement-variants-change-action>
      <app-download-itt-action
        [product]="product"
        [assetType]="'shoot-asset'"
      ></app-download-itt-action>
    </div>
  </div>
}

@for (item of content; track item; let i = $index) {
  <div [ngClass]="{ loading: isLoading }">
    <mat-expansion-panel expanded="true">
      <mat-expansion-panel-header>
        <mat-panel-title style="justify-content: space-between">
          <div class="touch">
            <div>
              @if (displaySelectTouch[item.id]) {
                <mat-checkbox
                  (click)="$event.stopPropagation()"
                  (change)="selectedAllTouch($event.checked, item)"
                  [checked]="item.selectedTouch"
                  [color]="'primary'"
                ></mat-checkbox>
              }
            </div>
            <div class="touch-info">
              <div class="touch-title">Touch {{ i + 1 }}</div>
              <div class="touch-description">{{ item.name }}</div>
            </div>
          </div>
          <div
            [matTooltip]="
              item.quantitySelected === 0
                ? 'Select Assets to transfer to MS Placeholders'
                : 'Transfer ' + item.quantitySelected + ' Selected Assets to MS Placeholders'
            "
            (click)="$event.stopPropagation()"
            >
            <button
              mat-icon-button
              (click)="transferProductAsset(item.id)"
              [disabled]="item.quantitySelected === 0"
              >
              <mat-icon>move_up</mat-icon>
            </button>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div
        class="step-list"
        [ngStyle]="{ 'grid-template-columns': 'repeat(' + colPerScreen + ',minmax(0,1fr))' }"
        >
        @for (asset of item.assets; track asset) {
          <app-card-item
            [showParentInfo]="!!asset.childIndex"
            [dataType]="'production'"
            [data]="asset"
            [editCallback]="editCallback"
            [touchId]="item.id"
            [releasedInCollection]="product.releasedInCollection"
            (done)="updateRowHeight()"
            (selectedCheckbox)="selectedCard($event)"
          ></app-card-item>
        }
      </div>
    </mat-expansion-panel>
  </div>
}
